import { Component, computed, input } from '@angular/core';
import { Branding, emptyBrandingInfo } from 'app/core/auth/user.model';


@Component({
    selector: 'branding-component',
    styles: [
        `
        @media screen, print {
            .branding {
                width: 100%;
                background: white;
                font-size: 12px;
                line-height: 1.25;
            }
            .info {
                padding: 15px;
            }
            .info-container {
                display: flex;
            }
            .personal-photo {
                height: 140px;
                margin-right: 15px;
            }
            .company-logo {
                height: 140px;
                margin-left: 15px;
            }
            .personal-info {
                flex-grow: 1;
            }

            .slogan {
                margin-top: 10px;
                margin-bottom: 0;
            }
            .trademark-statement {
                color: grey;
                font-size: 10px;
            }
            .trademark-statement.trademark-info {
                margin-left: 15px;
                margin-right: 15px;
                margin-bottom: 10px;
            }
            .trademark-statement.trademark-banner {
                margin: 10px 30px;
            }
        }
        `,
    ],
    template: `
        @if (branding()?.[type()] === 'banner' && branding()?.banner) {
            <div class="branding">
                <div class="banner">
                    <img [src]="branding()?.banner" width="100%">
                </div>
            </div>
        }
        @else if (branding()?.[type()] === 'info' && !emptyBrandingInfo()) {
            <div class="branding">
                <div class="info">
                    <div class="info-container">
                        @if (branding()?.personalPhoto) {
                            <img [src]="branding()?.personalPhoto" class="personal-photo">
                        }
                        <div class="personal-info">
                            <div [style.color]="fontColor()">{{ branding()?.name }}</div>
                            <div [style.color]="fontColor()">{{ branding()?.companyName }}</div>
                            <div>{{ branding()?.officeLocation }}</div>
                            @if (branding()?.cellPhone) {
                                <div>P: {{ branding()?.cellPhone }}</div>
                            }
                            @if (branding()?.officePhone) {
                                <div>O: {{ branding()?.officePhone }}</div>
                            }
                            <div>{{ branding()?.fax }}</div>
                            <div>{{ branding()?.email }}</div>
                            <div>{{ branding()?.url }}</div>
                        </div>
                        @if (branding()?.companyLogo) {
                            <img [src]="branding()?.companyLogo" class="company-logo">
                        }
                    </div>
                    @if (branding()?.slogan) {
                        <div class="slogan">{{ branding()?.slogan }}</div>
                    }
                </div>
                @if (creaTrademarkStatement()) {
                    <div class="trademark-statement trademark-{{ branding()?.[type()] }}">
                        {{ creaTrademarkStatement() }}
                    </div>
                }
            </div>
        }
    `,
})
export class BrandingComponent {

    branding = input.required<Branding | null>();

    type = input.required<'cmaType' | 'reportType' | 'summaryType' | 'featureSheetType'>();

    creaTrademarkStatement = input<string | null>();

    fontColor = computed(() => this.branding()?.color === '#FFFFFF' ? this.branding()?.background : '#000000');

    emptyBrandingInfo = computed(() => emptyBrandingInfo(this.branding()));
}
